import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Menu, Icon} from 'antd'
import {Link} from 'react-router-dom'
import CustomScrollbars from 'util/CustomScrollbars'
import SidebarLogo from './SidebarLogo'
import IntlMessages from 'util/IntlMessages'
import {NAV_STYLE_MINI, THEME_TYPE_LITE} from 'constants/ThemeSetting'
import Auxiliary from 'util/Auxiliary'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup

class SidebarContent extends Component {
  users = () => {
    if (localStorage.getItem('user_id') == 1) {
      return (
        <Menu.Item key="main/admin">
          <Link to="/main/admin">
            <Icon type="user" />
            <IntlMessages id="sidebar.users" />
          </Link>
        </Menu.Item>
      )
    }
  }

  products = () => {
    if (localStorage.getItem('user_id') == 1) {
      return (
        <Menu.Item key="main/products">
          <Link to="/main/products">
            <Icon type="shopping-cart" />
            <IntlMessages id="sidebar.products" />
          </Link>
        </Menu.Item>
      )
    }
  }

  notification = () => {
    if (localStorage.getItem('user_id') == 1) {
      return (
        <Menu.Item key="main/notification">
          <Link to="/main/notification">
            <i className="icon icon-sent" />
            <IntlMessages id="sidebar.notifications" />
          </Link>
        </Menu.Item>
      )
    }
  }

  orders = () => {
    if (localStorage.getItem('user_id') == 1) {
      return (
        <Menu.Item key="main/orders">
          <Link to="/main/orders">
            <Icon type="idcard" />
            <IntlMessages id="sidebar.orders" />
          </Link>
        </Menu.Item>
      )
    }
  }

  notifications = () => {
    if (localStorage.getItem('user_id') == 1) {
      return (
        <Menu.Item key="main/notifications">
          <Link to="/main/notifications">
            <i className="icon icon-sent" />
            <IntlMessages id="sidebar.notifications" />
          </Link>
        </Menu.Item>
      )
    }
  }

  render() {
    const {
      navStyle,
      themeType,
      verticalNavStyle,
      pathname,
      authUser,
    } = this.props
    const selectedKeys = pathname.substr(1)
    const defaultOpenKeys = selectedKeys.split('/')[1]

    return(
      <Auxiliary>
        <SidebarLogo />
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            inlineCollapsed={verticalNavStyle === NAV_STYLE_MINI}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            defaultOpenKeys={['sub1', 'main']}
            mode="inline"
          >
          <MenuItemGroup
              key="main"
              title={<IntlMessages id="sidebar.main" />}
            >
            {this.orders()}
            {this.users()}
            {this.products()}
            {this.notification()}
          </MenuItemGroup>
          </Menu>
        </CustomScrollbars>
      </Auxiliary>
    )

    /*return (
      <Auxiliary>
        <SidebarLogo />
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            inlineCollapsed={verticalNavStyle === NAV_STYLE_MINI}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            defaultOpenKeys={['sub1', 'main']}
            mode="inline"
          >
            <MenuItemGroup
              key="main"
              title={<IntlMessages id="sidebar.main" />}
            >
              <SubMenu
                key="sub1"
                title={
                  <span>
                    {' '}
                    <i className="icon icon-tickets" />
                    <IntlMessages id="sidebar.cupones" />
                  </span>
                }
              >
                <Menu.Item key="main/coupons/verified">
                  <Link to="/main/coupons/verified">
                    <i className="icon icon-check" />
                    <IntlMessages id="sidebar.cupones.comprobar" />
                  </Link>
                </Menu.Item>
                <Menu.Item key="main/coupons/list">
                  <Link to="/main/coupons/list">
                    <i className="icon icon-table-data" />
                    <IntlMessages id="sidebar.cupones.list" />
                  </Link>
                </Menu.Item>
                {this.coupons()}
                {this.categories()}
              </SubMenu>
              {this.products()}
              {this.users()}
              {this.stores()}
              {this.reports()}
              {this.notifications()}
            </MenuItemGroup>
          </Menu>
        </CustomScrollbars>
      </Auxiliary>
    )*/
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {navStyle, verticalNavStyle, themeType, locale, pathname} = settings
  const {authUser} = auth
  return {navStyle, verticalNavStyle, themeType, locale, pathname, authUser}
}
export default connect(mapStateToProps)(SidebarContent)



// WEBPACK FOOTER //
// ./src/containers/Sidebar/SidebarContent.js